<template>
  <div class="novedad-content">
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary">
        <v-card-text>
          <div class="loadTitle">
            <img :src="images.logo" /> <label>Cargando...</label>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <section class="novedad">
      <div class="novedad-item">
        <div class="novedad-header">
          <h2 v-html="contenido.post_title"></h2>
        </div>
        <div class="novedad-body" v-html="contenido.post_content"></div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { GET_CONTENIDO } from "@/core/services/store/contenido.module";
moment.locale("es");
export default {
  name: "index",
  components: {},
  data() {
    return {
      images: {
        family: process.env.BASE_URL + "media/family.jpg",
        logo: process.env.BASE_URL + "media/logo.png",
      },
      loading: true,
      isFullPage: true,
      activeTab: 0,
      showBooks: false,
      index: null,
      catVirtual: false,
      paseoVirtual: false,
      propiedades: [{}],
      isOpen: false,
      isCardModalActive: false,
    };
  },
  mounted() {
    this.getContenido();
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.$route.params.name = to.params.name;
    this.getContenido();
    this.isCardModalActive = false;
    next();
  },
  methods: {
    getContenido() {
      this.$Progress.start();
      this.$store.dispatch(GET_CONTENIDO, this.$route.params.name).then(() => {
        this.$Progress.finish();
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.agreement.errors,
      contenido: (state) => state.contenido.contenido,
    }),
  },
};
</script>

<style lang="scss" scoped>
.novedad-content {
  padding: 0 5% 3%;
  @media screen and(max-width:1024px) {
    padding-top: 120px;
  }
}
.novedad {
  .novedad-item {
    padding: 0 3% 5%;
    display: grid;
    row-gap: 20px;
    .novedad-header {
      padding: 20px;
      background: #7cacd3;
      height: 170px;
      display: flex;
      align-items: center;
      position: relative;
      @media screen and(max-width:1024px) {
        height: 150px;
      }
      h2 {
        width: 100%;
        color: #fff;
        text-transform: uppercase;
        text-align: center;
        font-family: Roboto, sans-serif;
        font-size: 30px;
        font-weight: 500;
        padding: 10px;
        overflow: hidden;
        height: auto;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        @media screen and(max-width:1024px) {
          font-size: 20px;
        }
      }
    }
    .novedad-body {
      text-align: left;
      font-size: 14px;
      color: var(--bricsa-grey);
      width: 70%;
      justify-self: center;
      @media screen and(max-width:426px) {
        width: 100%;
      }
    }
  }
}
</style>